/**
 * Retrieves or generates a hidden input after the provided input, so that it takes precedence in form submission
*/

import EventBus from './../event-bus.js'
import jQuery from 'jquery'

const GetHiddenInputModule = {

    /**
     * Get hidden input
     * @param params
    */
    getHiddenInput(params) {
    
        let
            form = params.hasOwnProperty('form') ? params.form : null,
            input = params.hasOwnProperty('input') ? params.input : null,
            name = params.hasOwnProperty('name') ? params.name : input.attr('name'),
            hiddenInput = (form ? form : input.closest('form')).find('input[type="hidden"][name="' + name + '"]')
            
        //Create hidden input if it does not already exist
        if (hiddenInput.length === 0) {
            hiddenInput = jQuery('<input type="hidden" name="' + name + '" />')
        }
        
        //Append to end of form if element specified
        if (form) {
            hiddenInput.appendTo(form)
        }
        else {
            hiddenInput.insertAfter(input)
        }
        
        params.callback(hiddenInput)
    
    },
    
    /**
     * Bind events
    */
    bindEvents() {
        EventBus.subscribe('get-hidden-input', this.getHiddenInput.bind(this))
    }

}

GetHiddenInputModule.bindEvents()

export default GetHiddenInputModule